import { media } from "@swa-ui/design-tokens/generated/grid";

export default {
  largeMax: `${media.large.max}px`,
  largeMin: `${media.large.min}px`,
  mediumMax: `${media.medium.max}px`,
  mediumMin: `${media.medium.min}px`,
  smallMax: `${media.small.max}px`,
  smallMin: `${media.small.min}px`,
  xlargeMin: `${media.xlarge.min}px`,
};
